import { SYSTEM_SINGLE_RATES, SYSTEM_TIER_RATES } from '../constants'

export const getActiveTierIndex = (totalAmount: number): number => {
  if (totalAmount >= 3000000) return 2
  if (totalAmount >= 500000) return 1
  if (totalAmount >= 0) return 0

  return -1
}

export type TierInfo = {
  rates: Array<string>
  activeIndex: number
}

const useCommissionTiers = (turnovers: { [code: string]: number } | null, isNewTab: boolean) => {
  const totalTurnover = turnovers ? Object.values(turnovers).reduce((sum, t) => sum + t, 0) : 0

  const activeIndex = getActiveTierIndex(totalTurnover)

  const getTierInfo = (systemCode: string): TierInfo => {
    if (isNewTab) {
      const singleRate = SYSTEM_SINGLE_RATES[systemCode]

      return { rates: [singleRate], activeIndex }
    }

    const tierRates = SYSTEM_TIER_RATES[systemCode]

    return { rates: tierRates, activeIndex }
  }

  return { getTierInfo }
}

export default useCommissionTiers
